import { runAutoDetect } from '~/features/grid/actions';
import { getCellRects } from '~/features/grid/cellRects';
import { useShortcut } from '~/features/shortcuts/useShortcut';
import { useStore } from '~/store';
import { guidelineCenter } from './guidelines';

export function useEditorShortcuts() {
  useShortcut('cancelDraw', () => {
    const s = useStore.getState();
    if (s.editor.selectedRegionId) {
      s.setSelectedRegionId(null);
      return;
    }
    if (s.editor.drawMode === 'selectRegion') {
      s.setDrawMode('none');
      return;
    }
    s.clearBoxSelection();
    s.clearBlobSelection();
    s.setDrawMode('none');
    s.setSelection(null);
  });
  useShortcut('drawWatermark', () => useStore.getState().setDrawMode('watermark'));
  useShortcut('pickBgColor', () => {
    const s = useStore.getState();
    if (!s.background.enabled) return;
    s.setDrawMode('pickBg');
  });
  useShortcut('keyRegion', () => {
    const s = useStore.getState();
    if (!s.background.enabled) return;
    s.setDrawMode('keyRegion');
  });
  useShortcut('eraseMode', () => {
    const s = useStore.getState();
    if (!s.background.enabled) return;
    s.setDrawMode(s.editor.drawMode === 'erase' ? 'none' : 'erase');
  });
  // Mac UX: users reach for Backspace, not the rarely-present Delete forward key.
  useShortcut('removeSelectedRegion', () => {
    const s = useStore.getState();
    if (s.editor.selectedRegionId) {
      s.removeRegion(s.editor.selectedRegionId);
      return;
    }
    const sel = s.editor.selectedEdge;
    if (sel?.kind === 'guideline') s.removeGuideline(sel.axis, sel.index);
  });
  useShortcut('autoDetectGrid', runAutoDetect);
  useShortcut('drawCrop', () => {
    const s = useStore.getState();
    if (s.workflow.step !== 'matte') return;
    s.setDrawMode('crop');
  });
  useShortcut('panMode', () => {
    const s = useStore.getState();
    s.setDrawMode(s.editor.drawMode === 'pan' ? 'none' : 'pan');
  });
  useShortcut('resetViewport', () => useStore.getState().resetViewport());
  useShortcut('toggleSnap', () => {
    const s = useStore.getState();
    s.setSnapToGuidelines(!s.editor.snapToGuidelines);
  });
  useShortcut('addVerticalGuideline', () => {
    const c = guidelineCenter('v');
    if (c != null) useStore.getState().addGuideline('v', c);
  });
  useShortcut('addHorizontalGuideline', () => {
    const c = guidelineCenter('h');
    if (c != null) useStore.getState().addGuideline('h', c);
  });
  useShortcut('selectRegion', () => useStore.getState().setDrawMode('selectRegion'));
  useShortcut('selectAllBoxes', () => {
    const s = useStore.getState();
    if (s.pin.framingMode === 'pin') {
      const blobs = s.pin.blobs;
      if (!blobs || blobs.length === 0) return;
      s.setSelectedBlobs(blobs.map((_, i) => i));
      return;
    }
    const cells = getCellRects(s.grid);
    if (cells.length === 0) return;
    s.setSelectedBoxes(cells.map((c) => c.box));
  });
}
